import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PartnerUserDto } from '../models/partner.model';
import { PartnerInvoiceDto } from '../models/invoice.model';
import { PaginatedResponse } from '../models/voucher.model';

@Injectable({
    providedIn: 'root'
})
export class PartnerService {
    private apiUrl = `${environment.apiConfig.uri}/api/Partner`;

    constructor(private http: HttpClient) { }

    /**
     * Get the current authenticated partner user profile
     * @returns Observable of PartnerUserDto
     */
    getMe(): Observable<PartnerUserDto> {
        return this.http.get<PartnerUserDto>(`${this.apiUrl}/users/me`);
    }

    /**
     * Get partner invoices
     * @param pageIndex - Page index (0-based)
     * @param pageSize - Page size
     * @returns Observable of paginated partner invoices
     */
    getInvoices(pageIndex: number = 0, pageSize: number = 20): Observable<PaginatedResponse<PartnerInvoiceDto>> {
        const params = new HttpParams()
            .set('pageIndex', pageIndex.toString())
            .set('pageSize', pageSize.toString());
        return this.http.get<PaginatedResponse<PartnerInvoiceDto>>(`${this.apiUrl}/invoices`, { params });
    }

}

